import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-detail-c" }
const _hoisted_2 = { style: {"font-size":"14px","color":"#121619","line-height":"22px","text-align":"left","font-style":"normal","text-transform":"none","margin-bottom":"25px"} }

import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { BaseTable, BaseButton, useTableColumn } from 'xrk-components';

import { orderFeeViewDetail } from '../data-source/apis';
import { getServiceCol } from '../fields/columns';
import { resolveServiceColGysx } from '../utils/get-service-fee-gysx';
import { downLoadReceipt } from '@/common/hooks/order/order-download';


export default /*#__PURE__*/_defineComponent({
  __name: 'finished-order-detail-s',
  setup(__props) {

const route = useRoute();

const detailInfo = computed(() => {
  return {
    orderId: +route.query.orderId,
    orderType: +route.query.orderType,
    taxPattern: +route.query.taxPattern,
    gysx: +route.query.gysx
  };
});

const tableColumns = ref<any[]>([]);
const dataList = ref<any[]>([]);
const tips = ref('');

const getListAjax = async () => {
  const reqData = {
    id: detailInfo.value.orderId,
    orderType: detailInfo.value.orderType
  };
  const { data } = await orderFeeViewDetail(reqData);
  tips.value = data.calculationFormula;
  dataList.value = [data];

  // 列中间位：优先用详情接口 serviceFeeAmountType（向日葵经营个体），否则用列表 gysx
  const gysx = resolveServiceColGysx(
    data.serviceFeeAmountType,
    route.meta.taxType as number,
    detailInfo.value.taxPattern,
    detailInfo.value.gysx
  );
  const entry = [
    detailInfo.value.orderType,
    gysx,
    detailInfo.value.taxPattern
  ].join('-');
  tableColumns.value = [
    ...(getServiceCol(entry)?.cols || []),
    useTableColumn({
      align: 'center',
      fixed: 'right',
      label: '操作',
      width: 230,
      render({ row }) {
        return (
          <>
            <div>
              <BaseButton
                disabled={!row.receiptUrl || row.receiptUrl === '-'}
                onClick={async () => {
                  // 下载回单
                  downLoadReceipt(row.receiptUrl);
                }}
                type="text"
              >
                下载回单
              </BaseButton>
            </div>
          </>
        );
      }
    })
  ].filter(Boolean);
};
getListAjax();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(tips.value), 1),
    _createVNode(_unref(BaseTable), {
      data: dataList.value,
      columns: tableColumns.value
    }, null, 8, ["data", "columns"])
  ]))
}
}

})